import { createSlice } from "@reduxjs/toolkit";

// Create a slice for categories
const campaignSlice = createSlice({
  name: "campaign",
  initialState: {
    campaignItems: [],
    campaign: {},
    loading: false,
    error: null,
  },
  reducers: {
    setCampaignItems: (state, action) => {
      state.campaignItems = action.payload.data || [];
      state.loading = false;
    },
    setCampaign: (state, action) => {
      state.campaign = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectCampaignLoading = (state) => state.campaign.loading;
export const selectCampaignError = (state) => state.campaign.error;
export const selectCampaignItems = (state) => state.campaign.campaignItems;
export const selectCampaign = (state) => state.campaign.campaign;

// Export the reducer to include in the store
export const { setCampaign, setCampaignItems } = campaignSlice.actions;
export default campaignSlice.reducer;
